// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
//移动端适配库
import 'lib-flexible/flexible'
//css样式
import '@/assets/styles/reset.css'
//解决一像素边框
import '@/assets/styles/border.css'
import '@/pages/stylesheet/common.styl'
import '@/router/permission'

//引入字体库
import './assets/font/font.css'

import less from 'less'
Vue.use(less)

import '@/assets/icon/iconfont.css'
// import 'vant/lib/index.css';
import '@/assets/styles/vant.css'

//自定义全局loading
import loading from './components/loading/loading' // 引入loading
Vue.use(loading)
import maudio from './components/audio/audio' // 引入loading
Vue.use(maudio)

import { Icon } from 'vant';
Vue.use(Icon);
import { Step,Steps} from 'vant';
// import Step from './components/step' // 引入step

Vue.use(Step);
Vue.use(Steps);

//vantUI按需引入
import { Tabbar, TabbarItem } from 'vant';
Vue.use(Tabbar);
Vue.use(TabbarItem);

import { Tab, Tabs } from 'vant';

Vue.use(Tab);
Vue.use(Tabs);

import { List } from 'vant';
Vue.use(List);

import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);

import { Empty } from 'vant';
Vue.use(Empty);

import { Calendar } from 'vant';
Vue.use(Calendar);

import { Button, Toast} from 'vant';
Vue.use(Button);
Vue.use(Toast);
import { Loading } from 'vant';
Vue.use(Loading);
import { Field } from 'vant';
Vue.use(Field);
import { NavBar } from 'vant';
Vue.use(NavBar);
import { CountDown } from 'vant';
Vue.use(CountDown);
import { Popup } from 'vant';
Vue.use(Popup);
import { Dialog } from 'vant';
Vue.use(Dialog);
import { Circle } from 'vant';
Vue.use(Circle);
import { AddressEdit } from 'vant';
Vue.use(AddressEdit);
import { Overlay } from 'vant';
Vue.use(Overlay);
import { Divider } from 'vant';
Vue.use(Divider);
import { PullRefresh } from 'vant';
Vue.use(PullRefresh);

import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);

import { Progress } from 'vant';
Vue.use(Progress);
import Histogram from 'v-charts/lib/histogram.common'
Vue.component(Histogram.name, Histogram)

// import { ActionSheet } from 'vant';
// Vue.use(ActionSheet);

// 手机端调试工具
import VConsole from 'vconsole'
if (process.env.NODE_ENV === "development") {//开发环境
  new VConsole()
}

//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



//////////////////
// WEBPACK FOOTER
// ./app/main.js
// module id = null
// module chunks = 